"use client"

import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Badge } from "@/components/ui/badge"

export default function PersonProfile({ person, onClick }) {
    if (!person) return null

    const initials = person.name.substring(0, 2)
    const isFoo = person.id.startsWith("foo")

    return (
        <div
            className="flex items-center gap-3 p-2 rounded-md hover:bg-muted transition-colors cursor-pointer border border-input"
            onClick={() => onClick && onClick(person)}
        >
            <Avatar className="border-2 border-primary">
                <AvatarFallback>{initials}</AvatarFallback>
            </Avatar>
            <div>
                <div className="flex items-center gap-2">
                    <span className="font-medium">{person.name}</span>
                    {isFoo && (
                        <Badge variant="outline" className="text-xs">
                            Foo
                        </Badge>
                    )}
                    {!isFoo && (
                        <Badge variant="outline" className="text-xs bg-secondary text-secondary-foreground">
                            Doe
                        </Badge>
                    )}
                </div>
                <p className="text-lg text-foreground">"{person.tag}"</p>
            </div>
        </div>
    );
} 